import styled from 'styled-components';

export const AttachmentsWrap = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;



// WEBPACK FOOTER //
// ./src/components/attachments/styled-components.js